import { Component } from "react"

class Language extends Component{
    constructor(props){
        super(props)
        this.name = "言語"
    }
    validate(callbackDialog){
        if(String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(!(this.props === "ja" 
            || this.props === "en"
            || this.props === "zhtw"
            || this.props === "zhCN"
            || this.props === "ko"
        )){
            callbackDialog("エラー",this.name + "は表示されている選択欄から選択してください。")
            return false
        }
        return true
    }
}

export default Language;